import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import HelpConcierge from "./HelpConcierge";

export default function Layout() {
  return (
    <div className="min-h-screen bg-[#0B0C10] text-[#F5F5F7] font-body antialiased flex flex-col">
      <Navbar />
      <main className="flex-1 pt-20">
        <Outlet />
      </main>
      <Footer />
      <HelpConcierge />
    </div>
  );
}
